import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {getTranslate} from 'react-localize-redux';
import Validator from 'validatorjs';
import api from '../../helpers/api';
import {loadLanguage} from '../../common/redux/localeReducer';
import {notifySuccess, notifyError} from '../../common/redux/notificationReducer';
import {SectionLoader} from '../../common/components/loader';
import {Error, Label, Textarea} from '../../common/components/form';
import Modal from "react-bootstrap-modal";
import PropTypes from "prop-types";

class CreateAndonFormModal extends Component {
	constructor(props) {
		super(props);

		const {loadLanguage} = props;
		const andonForm = {
			"en": {
				"andon_form_modal_title": "Andon",
				"andon_form_business_unit_id": "Business Unit:",
				"andon_form_business_unit_andon_id": "Type:",
				"andon_form_issue": "Issue:",
				"andon_form_note": "Note:",
				"andon_form_attachment": "Attachment:",
				"andon_form_business_unit_id_required": "Business Unit is required.",
				"andon_form_business_unit_andon_id_required": "Type is required.",
				"andon_form_issue_required": "Issue is required."
			},
			"es": {
				"andon_form_modal_title": "Andon",
				"andon_form_business_unit_id": "Business Unit:",
				"andon_form_business_unit_andon_id": "Type:",
				"andon_form_issue": "Issue:",
				"andon_form_note": "Note:",
				"andon_form_attachment": "Attachment:",
				"andon_form_business_unit_id_required": "Business Unit is required.",
				"andon_form_business_unit_andon_id_required": "Type is required.",
				"andon_form_issue_required": "Issue is required."
			}
		};
		loadLanguage(andonForm);

		this.state = {
			isLoading: true,
			isUploading: false,
			isFormSubmitting: false,
			errors: {},
			allBusinessUnits: [],
			allBusinessUnitAndons: [],
			businessUnitList: [],
			businessUnitAndonList: [],
			andonForm: {
				id: 'New',
				business_unit_id: '',
				business_unit_andon_id: '',
				name: '',
				type: '',
				number: '',
				issue: '',
				note: '',
				documents: ''
			}
		}
	}

	_closeModal = () => {
		const {closeAction} = this.props;

		this.setState({errors: {}, andonForm: {
			id: 'New',
			business_unit_id: '',
			business_unit_andon_id: '',
			name: '',
			type: '',
			number: '',
			issue: '',
			note: '',
			documents: ''
		}});
		closeAction();
	};

	createAndonAction = async (e) => {
		const {notifySuccess, notifyError} = this.props;
		try {
			const response = await api.post('/andon/send-notification');
			console.log(response);
			notifySuccess(response.message);
		} catch (error) {
			notifyError(error.message);
		}
	};

	// componentDidMount() {
	// 	this.loadAndonForm();
	// }

	componentDidUpdate(prevProps) {
		const {show} = prevProps;
		const {show: newShow} = this.props;
		if(show !== newShow && newShow === true) {
			this.loadAndonForm();
		}
	}

	loadAndonForm = async () => {
		const {notifyError} = this.props;
		try {
			const response = await api.get('/andon/create');

			const allBusinessUnits = response.data.business_units;

			const businessUnitList = response.data.business_units.map(item => ({
				value: item.id,
				label: item.name
			}));

			this.setState({
				isLoading: false,
				allBusinessUnits: allBusinessUnits,
				allBusinessUnitAndons: [],
				businessUnitList: businessUnitList,
				businessUnitAndonList: []
			});
		} catch (error) {
			notifyError(error.message);
		}
	};

	updateState = (object) => {
		this.setState({
			andonForm: {
				...this.state.andonForm,
				...object
			}
		})
	};

	formSubmit = (e) => {
		e.preventDefault();
		const {andonForm} = this.state;

		const validators = {
			'business_unit_id': 'required',
			'business_unit_andon_id': 'required',
			'issue': 'required'
		};

		const messages = {
			"required.business_unit_id": "andon_form_business_unit_id_required",
			"required.business_unit_andon_id": "andon_form_business_unit_andon_id_required",
			"required.issue": "andon_form_issue_required"
		};
		let validation = new Validator(andonForm, validators, messages);
		if(validation.fails()) {
			return this.setState({errors: validation.errors.all()});
		}

		return this.handleSubmit(andonForm);
	};

	handleSubmit = async (values) => {
		const {notifySuccess, notifyError, closeAction} = this.props;
		try {
			this.setState({isFormSubmitting: true});
			const formData = Object.assign({}, values);
			const response = await api.post('/andon/create', formData);
			notifySuccess(response.message);

			this.setState({errors: {}, isFormSubmitting: false, andonForm: {
				id: 'New',
				business_unit_id: '',
				business_unit_andon_id: '',
				name: '',
				type: '',
				number: '',
				issue: '',
				note: '',
				documents: ''
			}});
			closeAction();
		} catch (error) {
			notifyError(error.message);
		}
	};

	businessUnitSelected = (id) => {
		id = parseInt(id);
		const {allBusinessUnits} = this.state;
		const businessUnit = allBusinessUnits.find(item => item.id === id);

		const allBusinessUnitAndons = businessUnit.business_unit_andons;
		const businessUnitAndonList = allBusinessUnitAndons.map(item => ({
			value: item.id,
			label: item.name
		}));

		const andonForm = {
			...this.state.andonForm,
			business_unit_id: businessUnit.id,
			business_unit_andon_id: '',
			name: '',
			type: ''
		};

		this.setState({
			allBusinessUnitAndons: allBusinessUnitAndons,
			businessUnitAndonList: businessUnitAndonList,
			andonForm: andonForm
		});
	};

	businessUnitAndonSelected = (id) => {
		id = parseInt(id);
		const {allBusinessUnitAndons} = this.state;
		const businessUnitAndon = allBusinessUnitAndons.find(item => item.id === id);

		this.setState({
			andonForm: {
				...this.state.andonForm,
				business_unit_andon_id: businessUnitAndon.id,
				name: businessUnitAndon.name,
				type: businessUnitAndon.type
			}
		});
	};

	documentsUpload = async (e) => {
		const {notifyError} = this.props;
		const documentFiles = e.target.files;
		if(documentFiles.length) {
			this.setState({ isUploading: true });
			try {
				const formData = new FormData();
				for(let i = 0; i < documentFiles.length; i++) {
					formData.append('documents', documentFiles[i]);
				}

				const response = await api.post('andon/upload', formData);
				const files = response.data.documents;
				const documentsArray = files.map(item => item.filename);
				this.updateState({documents: documentsArray.join('|')});
				this.setState({ isUploading: false });
			} catch (error) {
				notifyError(error.message);
				this.setState({ isUploading: false });
			}
		} else {
			this.updateState({documents: ''});
		}
	};

	render() {
		const {translate, show} = this.props;
		const {isLoading, isUploading, isFormSubmitting, errors, businessUnitList, businessUnitAndonList, andonForm} = this.state;

		const content = (
			<form onSubmit={this.formSubmit}>
				<div className="row">
					<div className="col-sm-12">
						<div className="form-group">
							<Label text={translate('andon_form_business_unit_id')}/>
							<div id="unit-inspection-defects-div">
								{
									businessUnitList.map((item, index) => (
										<button
											key={`andon_form_business_unit_${index}`}
											type="button"
											style={{margin: '5px'}}
											className={`btn btn-default btn-inverse ${item.value === andonForm.business_unit_id ? 'selected' : ''}`}
											value={item.value}
											onClick={e => this.businessUnitSelected(e.target.value)}
										>
											{item.label}
										</button>
									))
								}
							</div>
							{errors.business_unit_id && <Error text={translate(errors.business_unit_id[0])}/>}
						</div>

						<div className="form-group">
							<Label text={translate('andon_form_business_unit_andon_id')}/>
							{
								(businessUnitAndonList.length > 0) && (
									<div id="unit-inspection-defects-div">
										{
											businessUnitAndonList.map((item, index) => (
												<button
													key={`andon_form_business_unit_andon_${index}`}
													type="button"
													className={`btn btn-default btn-inverse ${item.value === andonForm.business_unit_andon_id ? 'selected' : ''}`}
													value={item.value}
													onClick={e => this.businessUnitAndonSelected(e.target.value)}
												>
													{item.label}
												</button>
											))
										}
									</div>
								)
							}
							{errors.business_unit_andon_id && <Error text={translate(errors.business_unit_andon_id[0])}/>}
						</div>

						<div className="form-group">
							<Label text={translate('andon_form_issue')}/>
							<Textarea value={andonForm.issue} onChange={e => this.updateState({issue: e.target.value})}/>
							{errors.issue && <Error text={translate(errors.issue[0])}/>}
						</div>

						<div className="form-group">
							<Label text={translate('andon_form_note')}/>
							<Textarea value={andonForm.note} onChange={e => this.updateState({note: e.target.value})}/>
							{errors.note && <Error text={translate(errors.note[0])}/>}
						</div>

						{
							!isFormSubmitting && (
								<div className="form-group">
									<Label text={translate('andon_form_attachment')}/>
									<input type="file" multiple={true} className="form-control" onChange={this.documentsUpload} />
									{errors.attachment && <Error text={translate(errors.attachment[0])} />}
									{isUploading && <p>Uploading...</p>}
								</div>
							)
						}
					</div>
				</div>
				<div className="row">
					<div className="col-sm-12 text-center">
						{isUploading && <button type="button" className="btn btn-primary"><i className="fa fa-refresh fa-spin"/></button>}
						{!isUploading && <button type="submit" className="btn btn-primary btn-inverse">{translate('common.submit')}</button>}
						<button type="button" className="btn btn-danger btn-inverse" onClick={this._closeModal}>{translate('common.cancel')}</button>
					</div>
				</div>
			</form>
		);

		return (
			<Modal show={show} onHide={this._closeModal}>
				<Modal.Header closeButton>
					<Modal.Title id='AndonModalHeader'>{translate('andon_form_modal_title')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
				{
					!isLoading ? content : <SectionLoader/>
				}
				</Modal.Body>
			</Modal>
		)
	}
}

CreateAndonFormModal.propTypes = {
	show: PropTypes.bool.isRequired,
	closeAction: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
	translate: getTranslate(state.locale)
});

const mapDispatchToProps = dispatch => bindActionCreators({
	loadLanguage,
	notifySuccess,
	notifyError
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CreateAndonFormModal);
